var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9801 2.54047C19.4335 3.90011 20.25 5.74417 20.25 7.66699C20.25 16.1253 24.125 18.542 24.125 18.542H0.875C0.875 18.542 4.75 16.1253 4.75 7.66699C4.75 5.74417 5.56652 3.90011 7.01992 2.54047C8.47333 1.18083 10.4446 0.416992 12.5 0.416992C14.5554 0.416992 16.5267 1.18083 17.9801 2.54047ZM11.1153 22.848C10.8242 22.3786 10.2078 22.2341 9.73843 22.5251C9.26906 22.8162 9.12451 23.4326 9.41556 23.902C9.73798 24.422 10.1956 24.8455 10.7363 25.1369C11.2766 25.428 11.8846 25.5791 12.5 25.5791C13.1154 25.5791 13.7234 25.428 14.2637 25.1369C14.8044 24.8455 15.262 24.422 15.5845 23.902C15.8755 23.4326 15.731 22.8162 15.2616 22.5251C14.7922 22.2341 14.1758 22.3786 13.8847 22.848C13.753 23.0605 13.5587 23.2449 13.315 23.3762C13.071 23.5077 12.7897 23.5791 12.5 23.5791C12.2103 23.5791 11.929 23.5077 11.685 23.3762C11.4413 23.2449 11.2471 23.0605 11.1153 22.848Z",
    fill: "url(#paint0_linear_236_192)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_236_192",
    x1: 24,
    y1: -5,
    x2: 8,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D5BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6896FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.122db0a25ccd5f024ba6f3d94154fd55.svg";
export { ForwardRef as ReactComponent };